(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__slideLinkInit) return;
    window.__slideLinkInit = true;

    var startX = 0;
    var startY = 0;

    document.addEventListener(
      'pointerdown',
      function (event) {
        startX = event.clientX;
        startY = event.clientY;
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest && event.target.closest('.slide__link');
        if (!link) return;

        // Si el usuario ha arrastrado para cambiar de diapositiva, no navegamos
        if (
          event.detail !== 0 &&
          (Math.abs(event.clientX - startX) > 10 || Math.abs(event.clientY - startY) > 10)
        ) return;

        event.preventDefault();
        event.stopPropagation();

        if (event.metaKey || event.ctrlKey) {
          window.open(link.href, '_blank');
        } else {
          window.location.href = link.href;
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
